import { render, staticRenderFns } from "./ImagePreviewIcon.vue?vue&type=template&id=5860838e&"
import script from "./ImagePreviewIcon.vue?vue&type=script&lang=js&"
export * from "./ImagePreviewIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports